import { motion, useReducedMotion } from 'framer-motion';

const Marquee = ({ items, separator = '/' }) => {
  const reduceMotion = useReducedMotion();
  const track = [...items, ...items];

  if (reduceMotion) {
    return (
      <div className="relative overflow-hidden border-y border-white/[0.06] bg-white/[0.02] py-4">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 px-4">
          {items.map((item) => (
            <span key={item} className="font-mono text-sm tracking-wide text-white/40 whitespace-nowrap">
              {item}
            </span>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden border-y border-white/[0.06] bg-white/[0.02] py-4 marquee-fade">
      <motion.div
        className="flex w-max gap-8"
        animate={{ x: ['0%', '-50%'] }}
        transition={{ duration: 40, repeat: Infinity, ease: 'linear' }}
      >
        {track.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-8 shrink-0">
            <span className="font-mono text-sm tracking-wide text-white/40 whitespace-nowrap">
              {item}
            </span>
            <span className="text-white/15 font-light">{separator}</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;